import { Mirror } from './IBattleplanMap.js';
// Coordinates are on a 60" x 44" grid; mirror across the center (30, 22).
const MAP_W = 60;
const MAP_H = 44;
export function mirrorPoint(x, y, mirror) {
    switch (mirror) {
        case Mirror.X:
            return { x: MAP_W - x, y };
        case Mirror.Y:
            return { x, y: MAP_H - y };
        case Mirror.Both:
            return { x: MAP_W - x, y: MAP_H - y };
        default:
            return { x, y };
    }
}
function expandObjectives(objectives) {
    const result = [];
    for (const obj of objectives) {
        result.push({ type: obj.type, x: obj.x, y: obj.y });
        if (obj.mirror) {
            const m = mirrorPoint(obj.x, obj.y, obj.mirror);
            result.push({ type: obj.type, x: m.x, y: m.y });
        }
    }
    return result;
}
function expandTerrain(terrain) {
    const result = [];
    for (const t of terrain) {
        result.push({ type: t.type, size: t.size, x: t.x, y: t.y });
        if (t.mirror) {
            const m = mirrorPoint(t.x, t.y, t.mirror);
            result.push({ type: t.type, size: t.size, x: m.x, y: m.y });
        }
    }
    return result;
}
// Module-level registry, populated at app/tool startup from committed JSON.
// Keyed by battlepack; each value is the bundle's battleplan entries (map + any
// authored content), so the map overlay is read straight off the entry.
const registry = new Map();
// Registers or replaces the full battleplan set for a battlepack. Calling this
// twice with the same battlePack overwrites — not merges — the prior entries.
export function registerBattlepackBundle(bundle) {
    registry.set(bundle.battlePack, bundle.battleplans);
}
// Back-compat: register a legacy maps-only pack. Wraps each map as a bundle entry.
export function registerBattlepackMaps(packs) {
    for (const pack of packs) {
        const entries = {};
        for (const [name, map] of Object.entries(pack.maps))
            entries[name] = { map };
        registry.set(pack.battlePack, entries);
    }
}
export function clearBattlepackMaps() {
    registry.clear();
}
export function getBattleplanMap(battlePack, name) {
    const raw = registry.get(battlePack)?.[name]?.map;
    if (!raw)
        return null;
    // Pass every field through (zones, arrows, labels, icons, and anything added
    // later), overriding only the two that need mirror expansion. Listing fields
    // by hand here is what silently dropped icons from the preview.
    return {
        ...raw,
        objectives: expandObjectives(raw.objectives),
        terrain: expandTerrain(raw.terrain),
    };
}
